import React from 'react';
import {StorageKey} from "../../../enums/StorageKey";
import {Trans} from "@lingui/macro";
import BukkuTooltip from "../../Tooltip";

function getColumns() {
    return [
        {
            title: <Trans>id</Trans>,
            dataIndex: 'id',
            key: 'id',
            width: 140,
            ellipsis: true,
        },
        {
            title: <Trans>Number</Trans>,
            dataIndex: 'number',
            key: 'number',
            width: 130,
        },
        {
            title: <Trans>Transaction Type</Trans>,
            dataIndex: 'type',
            key: 'type',
            width: 140,
            ellipsis: true,
        },
        {
            title: <Trans>Description</Trans>,
            dataIndex: 'description',
            key: 'description',
            width: 130,
        },
        {
            title: <Trans>Remarks</Trans>,
            dataIndex: 'remarks',
            key: 'remarks',
            width: 130,
        },
        {
            title: <Trans>Created Date</Trans>,
            dataIndex: 'createdDate',
            key: 'createdDate',
            width: 140,
            ellipsis: true,
            render: text => (
                <div className="ellipsis-div">
                    <BukkuTooltip>
                        <span>{text || '-'}</span>
                    </BukkuTooltip>
                </div>
            ),
        },
        {
            title: <Trans>Updated Date</Trans>,
            dataIndex: 'updatedDate',
            key: 'updatedDate',
            align: 'right',
            width: 130,
        },
    ];
}

export default {
    storageKey: StorageKey.bukkuadmin_transaction_record,
    sortable: [
        'name',
        'sku',
        'quantity',
        'bin_location',
        'sale_price',
        'purchase_price',
        'margin_percent',
        'created_at',
    ],
    required: [
        'name',
        'action',
    ],
    defaulto: [
        'thumbnail_url',
        'sku',
        'quantity',
        'sale_price',
        'purchase_price',
    ],
    hideTitle: [
        'thumbnail_url',
    ],
    getColumns,
};
